import { useState } from 'react'
import { Button } from 'components'
import { CreateNewProductModal } from './CreateNewProductModal'

type ShowState = [boolean, (value: boolean) => void]

export const CreateNewProductButton = () => {
  const [show, setShow] = useState(false)

  const buttonText = '✨ Create New Product'

  return (
    <>
      <Button primary onClick={() => setShow(true)}>
        {buttonText}
      </Button>
      <CreateNewProductModal show={[show, setShow] as ShowState} />
    </>
  )
}

export default CreateNewProductButton
